// import { MapContainer, TileLayer, GeoJSON, Popup } from "react-leaflet";
// import { useState, useEffect } from "react";
// import "leaflet/dist/leaflet.css";
// import Papa from "papaparse";

// const WorldMap = () => {
//   const [geoData, setGeoData] = useState(null);
//   const [countryData, setCountryData] = useState([]);
//   const [popupContent, setPopupContent] = useState(null);
//   const [colorMap, setColorMap] = useState({});

//   useEffect(() => {
//     fetch("https://raw.githubusercontent.com/datasets/geo-countries/master/data/countries.geojson")
//       .then((response) => response.json())
//       .then((data) => {
//         setGeoData(data);
//       })
//       .catch((error) => console.error("Error loading GeoJSON:", error));
//   }, []);

//   useEffect(() => {
//     fetch("/arrivals_soe.csv")
//       .then((response) => response.text())
//       .then((text) => {
//         Papa.parse(text, {
//           header: true,
//           skipEmptyLines: true,
//           complete: (result) => {
//             setCountryData(result.data);
//           },
//         });
//       })
//       .catch((error) => console.error(" Error loading CSV:", error));
//   }, []);

//   const generateRandomColor = () => {
//     const letters = "0123456789ABCDEF";
//     let color = "#";
//     for (let i = 0; i < 6; i++) {
//       color += letters[Math.floor(Math.random() * 16)];
//     }
//     return color;
//   };

//   const getCountryColor = (countryISO) => {
//     if (!colorMap[countryISO]) {
//       colorMap[countryISO] = generateRandomColor();
//       setColorMap({ ...colorMap });
//     }
//     return colorMap[countryISO];
//   };

//   const getCountryArrivals = (countryISO) => {
//     const filtered = countryData.filter(
//       (row) => row.country?.trim().toUpperCase() === countryISO?.trim().toUpperCase()
//     );

//     if (filtered.length === 0) return null;

//     const totalArrivals = filtered.reduce(
//       (sum, row) => sum + (parseInt(row.arrivals.replace(/,/g, ""), 10) || 0),
//       0
//     );
//     const maleArrivals = filtered.reduce(
//       (sum, row) => sum + (parseInt(row.arrivals_male.replace(/,/g, ""), 10) || 0),
//       0
//     );
//     const femaleArrivals = filtered.reduce(
//       (sum, row) => sum + (parseInt(row.arrivals_female.replace(/,/g, ""), 10) || 0),
//       0
//     );
//     console.log('totalArrivals',totalArrivals)
//     console.log('maleArrivals',maleArrivals)
//     console.log('femaleArrivals',femaleArrivals)

//     return { totalArrivals, maleArrivals, femaleArrivals };
//   };



//   const onCountryClick = (event, feature) => {
//     const countryISO = feature.properties?.ISO_A3;
//     const countryName = feature.properties?.ADMIN;

//     if (!countryISO) return;

//     const arrivals = getCountryArrivals(countryISO);

//     if (arrivals) {
//       setPopupContent({
//         position: event.latlng,
//         content: (
//           <div>
//             <h3>{countryName}</h3>
//             <p>Total Arrivals: {arrivals.totalArrivals}</p>
//             <p>Male Arrivals: {arrivals.maleArrivals}</p>
//             <p>Female Arrivals: {arrivals.femaleArrivals}</p>
//           </div>
//         ),
//       });
//     } else {
//       setPopupContent({
//         position: event.latlng,
//         content: (
//           <div>
//             <h3>{countryName}</h3>
//             <p>No data available for this country.</p>
//           </div>
//         ),
//       });
//     }
//   };

//   return (
//     <div
//       style={{
//         width: "100%",
//         height: "500px",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//       }}
//     >
//       <MapContainer center={[20, 0]} zoom={2} style={{ height: "100%", width: "100%" }}>
//         <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />

//         {geoData && (
//           <GeoJSON
//             data={geoData}
//             style={(feature) => {
//               const countryISO = feature.properties?.ISO_A3;
//               const countryColor = getCountryColor(countryISO);

//               return {
//                 fillColor: countryColor,
//                 color: "#333",
//                 weight: 1,
//                 fillOpacity: 0.7,
//                 interactive: true,
//               };
//             }}
//             onEachFeature={(feature, layer) => {
//               const countryISO = feature.properties?.ISO_A3;
//               const countryName = feature.properties?.ADMIN;

//               layer.options.interactive = true;
//               layer.setStyle({ cursor: "pointer" });

//               layer.on("mouseover", () => {
//                 const arrivals = getCountryArrivals(countryISO);
//                 if (arrivals) {
//                   layer.bindTooltip(
//                     `<strong>${countryName}</strong><br/>
//                      Total: ${arrivals.totalArrivals}<br/>
//                      Male: ${arrivals.maleArrivals}<br/>
//                      Female: ${arrivals.femaleArrivals}`,
//                     { sticky: true }
//                   ).openTooltip();
//                 } else {
//                   layer.bindTooltip(
//                     `<strong>${countryName}</strong><br/>No data available`,
//                     { sticky: true }
//                   ).openTooltip();
//                 }
//               });

//               layer.on("mouseout", () => {
//                 layer.closeTooltip();
//               });

//               layer.on("click", (event) => onCountryClick(event, feature));
//             }}
//           />
//         )}

//         {popupContent && (
//           <Popup
//             position={popupContent.position}
//             closeButton={true}
//             autoClose={false}
//             closeOnClick={false}
//           >
//             {popupContent.content}
//           </Popup>
//         )}
//       </MapContainer>
//     </div>
//   );
// };

// export default WorldMap;




import { MapContainer, TileLayer, GeoJSON, Popup, useMap } from "react-leaflet";
import { useState, useEffect } from "react";
import "leaflet/dist/leaflet.css";
import Papa from "papaparse";

const WorldMap = ({ showRight }) => {
  const [geoData, setGeoData] = useState(null);
  const [countryData, setCountryData] = useState([]);
  const [popupContent, setPopupContent] = useState(null);
  const [colorMap, setColorMap] = useState({});

  const ResizeMap = ({ dependency }) => {
    const map = useMap();
  
    useEffect(() => {
      const container = map?.getContainer();
      if (!container || container.offsetParent === null) return;
  
      const timeout = setTimeout(() => {
        map.invalidateSize();
      }, 300);
  
      return () => clearTimeout(timeout);
    }, [dependency, map]);
  
    return null;
  }

  useEffect(() => {
    fetch("https://raw.githubusercontent.com/datasets/geo-countries/master/data/countries.geojson")
      .then((response) => response.json())
      .then((data) => setGeoData(data))
      .catch((error) => console.error("Error loading GeoJSON:", error));
  }, []);

  useEffect(() => {
    fetch("/arrivals_soe.csv")
      .then((response) => response.text())
      .then((text) => {
        Papa.parse(text, {
          header: true,
          skipEmptyLines: true,
          complete: (result) => {
            setCountryData(result.data);
          },
        });
      })
      .catch((error) => console.error("Error loading CSV:", error));
  }, []);

  const generateRandomColor = () => {
    const letters = "0123456789ABCDEF";
    let color = "#";
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  };

  const getCountryColor = (countryISO) => {
    const iso = (countryISO || "").trim().toUpperCase();
    if (!colorMap[iso]) {
      const newColor = generateRandomColor();
      setColorMap((prev) => ({ ...prev, [iso]: newColor }));
      return newColor;
    }
    return colorMap[iso];
  };
  const getCountryArrivals = (countryISO) => {
    const iso = (countryISO || "").trim().toUpperCase();

    if (!iso) return null;

    const filtered = countryData.filter(
      (row) =>
        (row.country || "").trim().toUpperCase() === iso &&
        row.date === "2020-01-01"
    );

    console.log("🔍 Rows for", iso, filtered);

    if (filtered.length === 0) {
      return null;
    }

    const totalArrivals = filtered.reduce(
      (sum, row) => sum + (parseInt(row.arrivals, 10) || 0),
      0
    );

    const maleArrivals = filtered.reduce(
      (sum, row) => sum + (parseInt(row.arrivals_male, 10) || 0),
      0
    );

    const femaleArrivals = filtered.reduce(
      (sum, row) => sum + (parseInt(row.arrivals_female, 10) || 0),
      0
    );

    return { totalArrivals, maleArrivals, femaleArrivals };
  };



  const onCountryClick = (event, feature) => {
    const countryISO = feature.properties?.["ISO3166-1-Alpha-3"];
    const countryName = feature.properties?.["name"];
    if (!countryISO) return;

    const arrivals = getCountryArrivals(countryISO);

    setPopupContent({
      position: event.latlng,
      content: (
        <div>
          <h3>{countryName}</h3>
          {arrivals ? (
            <>
              <p>Total Arrivals: {arrivals.totalArrivals}</p>
              <p>Male Arrivals: {arrivals.maleArrivals}</p>
              <p>Female Arrivals: {arrivals.femaleArrivals}</p>
            </>
          ) : (
            <p>No data available for this country.</p>
          )}
        </div>
      ),
    });
  };

  return (
    <div style={{ width: "100%", height: "500px" }}>
      <MapContainer
        center={[0, 0]}
        zoom={2}
        minZoom={1.3}
        maxZoom={5}
        maxBounds={[
          [-90, -190],
          [90, 190],
        ]}
        maxBoundsViscosity={1.0}
        style={{ height: "100%", width: "100%" }}
      >
        <ResizeMap dependency={showRight} /> 
        <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />

        {geoData && (
          <GeoJSON
            data={geoData}
            style={(feature) => {
              const countryISO = feature.properties?.["ISO3166-1-Alpha-3"];
              const countryColor = getCountryColor(countryISO);
              return {
                fillColor: countryColor,
                color: "#333",
                weight: 1,
                fillOpacity: 0.7,
                interactive: true,
              };
            }}
            onEachFeature={(feature, layer) => {
              const countryISO = feature.properties?.["ISO3166-1-Alpha-3"];
              const countryName = feature.properties?.["name"];

              layer.options.interactive = true;
              layer.setStyle({ cursor: "pointer" });

              layer.on("mouseover", () => {
                const arrivals = getCountryArrivals(countryISO);
                const tooltipContent = arrivals
                  ? `<strong>${countryName}</strong><br/>Total: ${arrivals.totalArrivals}<br/>Male: ${arrivals.maleArrivals}<br/>Female: ${arrivals.femaleArrivals}`
                  : `<strong>${countryName}</strong><br/>No data available`;

                layer.bindTooltip(tooltipContent, { sticky: true }).openTooltip();
              });

              layer.on("mouseout", () => {
                layer.closeTooltip();
              });

              layer.on("click", (event) => onCountryClick(event, feature));
            }}
          />
        )}

        {popupContent && (
          <Popup
            position={popupContent.position}
            closeButton={true}
            autoClose={false}
            closeOnClick={false}
          >
            {popupContent.content}
          </Popup>
        )}
      </MapContainer>
    </div>
  );
};

export default WorldMap;





